const resolveAsArray = <T = unknown>(value: T | T[]): T[] => {
  if (Array.isArray(value)) return value;
  if (value === undefined || value === null) return [];
  return [value];
};

export default resolveAsArray;
